import { render, staticRenderFns } from "./RatingPlanList.vue?vue&type=template&id=fdea1b80&"
import script from "./RatingPlanList.vue?vue&type=script&lang=js&"
export * from "./RatingPlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports